import { useState } from 'react'

import TabKsDefinitifPltGuru from 'app/KinerjaShared/components/TabKsDefinitifPltGuru'

import type { TabFilterRoles } from 'types/kinerja-ks'
import type {
  TabsKsTabDetail,
  TabKsDefinitifPltGuruProps,
} from 'app/KinerjaShared/components/TabKsDefinitifPltGuru'

type Props = TabKsDefinitifPltGuruProps & {
  // Will be use to initialize the counters, without this, the counters will not be displayed upon first render
  initCounters?: Record<TabFilterRoles, number>

  // Callback function when tab is changed
  onChange?: (tab: TabsKsTabDetail) => void
}

type TabKsDefinitifPltGuru = {
  activeTab: TabsKsTabDetail
  activeTabIndex: number
  activeTabName: TabFilterRoles
  render: JSX.Element
  setCounters: (counters: Record<TabFilterRoles, number>) => void
  setDefaultTab: (tab: TabsKsTabDetail) => void
}

const useTabKsDefinitifPltGuru = (props?: Props): TabKsDefinitifPltGuru => {
  const [counters, setCounters] = useState<Record<TabFilterRoles, number>>(
    props?.initCounters || null
  )

  const [activeTab, setActiveTab] = useState<TabsKsTabDetail>()

  // Function to handle tab change
  const onTabChanged = (tab: TabsKsTabDetail) => {
    setActiveTab(tab)
  }

  return {
    activeTab,
    activeTabIndex: activeTab?.index,
    activeTabName: activeTab?.name as TabFilterRoles,
    setCounters,
    setDefaultTab: setActiveTab,
    render: (
      <TabKsDefinitifPltGuru
        defaultIndex={activeTab?.index}
        {...props}
        key={activeTab?.index}
        counters={counters}
        onChange={(tab) => {
          onTabChanged(tab)
          props?.onChange?.(tab)
        }}
      />
    ),
  }
}

export default useTabKsDefinitifPltGuru
